module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTkgNXYxNEg1VjVoMTRtMC0ySDVjLTEuMSAwLTIgLjktMiAydjE0YzAgMS4xLjkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJWNWMwLTEuMS0uOS0yLTItMnptLTQuODYgOC44NmwtMyAzLjg3TDkgMTMuMTQgNiAxN2gxMmwtMy44Ni01LjE0eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/ExternalLinksCollection/icons/outline-image-24px.svg
// module id = 441
// module chunks = 35783957827783